// extracted by mini-css-extract-plugin
module.exports = {"empty":"EmptySearch_empty__1Tnto"};